/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BillingPackages200,
  BillingPaymentConfirm200,
  BillingPaymentConfirmRequest,
  BillingPaymentPrepare200,
  BillingPaymentPrepareRequest,
  BillingPaymentRefund200,
  BillingPaymentRefundRequest,
  BillingTossWebhookRequest,
  Payment,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 구매 가능한 크레딧 패키지 목록을 반환합니다.
 * @summary 크레딧 패키지 목록
 */
export const billingPackages = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BillingPackages200>(
    { url: `/api/billing/packages/`, method: "GET", signal },
    options,
  );
};

export const getBillingPackagesQueryKey = () => {
  return [`/api/billing/packages/`] as const;
};

export const getBillingPackagesQueryOptions = <
  TData = Awaited<ReturnType<typeof billingPackages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof billingPackages>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingPackagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPackages>>> = ({
    signal,
  }) => billingPackages(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingPackages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingPackagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingPackages>>
>;
export type BillingPackagesQueryError = ErrorType<unknown>;

export function useBillingPackages<
  TData = Awaited<ReturnType<typeof billingPackages>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPackages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPackages>>,
          TError,
          Awaited<ReturnType<typeof billingPackages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPackages<
  TData = Awaited<ReturnType<typeof billingPackages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPackages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPackages>>,
          TError,
          Awaited<ReturnType<typeof billingPackages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPackages<
  TData = Awaited<ReturnType<typeof billingPackages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPackages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 크레딧 패키지 목록
 */

export function useBillingPackages<
  TData = Awaited<ReturnType<typeof billingPackages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPackages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingPackagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 결제 환불 (사용자 셀프 취소).

조건:
- 결제 후 7일 이내
- status=PAID
- 정기결제(빌링키)가 아님 — 정기결제는 SubscriptionCancelView로 처리
- 지급된 크레딧이 잔액에 그대로 남아있어야 (사용한 크레딧이 있으면 거부)

흐름:
1. Payment 조회 + 권한 확인
2. 7일 / 사용 / 이미 환불됨 검증
3. CreditWallet에서 받았던 크레딧 차감 (deduct_credits)
   — InsufficientCreditsError 시 "이미 사용한 크레딧" 400
4. 토스 결제 취소 API 호출
5. Payment.status=CANCELLED + refunded_at/amount/reason 저장
 * @summary 결제 환불 (7일 이내 미사용 크레딧 한정)
 */
export const billingPaymentRefund = (
  orderId: string,
  billingPaymentRefundRequest: BodyType<BillingPaymentRefundRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BillingPaymentRefund200>(
    {
      url: `/api/billing/payments/${orderId}/refund/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: billingPaymentRefundRequest,
      signal,
    },
    options,
  );
};

export const getBillingPaymentRefundMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingPaymentRefund>>,
    TError,
    { orderId: string; data: BodyType<BillingPaymentRefundRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingPaymentRefund>>,
  TError,
  { orderId: string; data: BodyType<BillingPaymentRefundRequest> },
  TContext
> => {
  const mutationKey = ["billingPaymentRefund"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingPaymentRefund>>,
    { orderId: string; data: BodyType<BillingPaymentRefundRequest> }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return billingPaymentRefund(orderId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingPaymentRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingPaymentRefund>>
>;
export type BillingPaymentRefundMutationBody =
  BodyType<BillingPaymentRefundRequest>;
export type BillingPaymentRefundMutationError = ErrorType<unknown>;

/**
 * @summary 결제 환불 (7일 이내 미사용 크레딧 한정)
 */
export const useBillingPaymentRefund = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingPaymentRefund>>,
      TError,
      { orderId: string; data: BodyType<BillingPaymentRefundRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingPaymentRefund>>,
  TError,
  { orderId: string; data: BodyType<BillingPaymentRefundRequest> },
  TContext
> => {
  const mutationOptions = getBillingPaymentRefundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 결제 최종 확인.

Toss 결제 완료 후 프론트에서 paymentKey/orderId/amount를 전달하면
서버에서 Toss API에 최종 승인 요청 후 크레딧을 지급합니다.
 * @summary 결제 확인 및 크레딧 지급
 */
export const billingPaymentConfirm = (
  billingPaymentConfirmRequest: BodyType<BillingPaymentConfirmRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BillingPaymentConfirm200>(
    {
      url: `/api/billing/payments/confirm/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: billingPaymentConfirmRequest,
      signal,
    },
    options,
  );
};

export const getBillingPaymentConfirmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingPaymentConfirm>>,
    TError,
    { data: BodyType<BillingPaymentConfirmRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingPaymentConfirm>>,
  TError,
  { data: BodyType<BillingPaymentConfirmRequest> },
  TContext
> => {
  const mutationKey = ["billingPaymentConfirm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingPaymentConfirm>>,
    { data: BodyType<BillingPaymentConfirmRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billingPaymentConfirm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingPaymentConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingPaymentConfirm>>
>;
export type BillingPaymentConfirmMutationBody =
  BodyType<BillingPaymentConfirmRequest>;
export type BillingPaymentConfirmMutationError = ErrorType<unknown>;

/**
 * @summary 결제 확인 및 크레딧 지급
 */
export const useBillingPaymentConfirm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingPaymentConfirm>>,
      TError,
      { data: BodyType<BillingPaymentConfirmRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingPaymentConfirm>>,
  TError,
  { data: BodyType<BillingPaymentConfirmRequest> },
  TContext
> => {
  const mutationOptions = getBillingPaymentConfirmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 결제 준비 — 주문 ID 발급.

프론트에서 Toss SDK 호출 전에 서버에서 orderId를 발급받습니다.
 * @summary 결제 준비 (orderId 발급)
 */
export const billingPaymentPrepare = (
  billingPaymentPrepareRequest: BodyType<BillingPaymentPrepareRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BillingPaymentPrepare200>(
    {
      url: `/api/billing/payments/prepare/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: billingPaymentPrepareRequest,
      signal,
    },
    options,
  );
};

export const getBillingPaymentPrepareMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingPaymentPrepare>>,
    TError,
    { data: BodyType<BillingPaymentPrepareRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingPaymentPrepare>>,
  TError,
  { data: BodyType<BillingPaymentPrepareRequest> },
  TContext
> => {
  const mutationKey = ["billingPaymentPrepare"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingPaymentPrepare>>,
    { data: BodyType<BillingPaymentPrepareRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billingPaymentPrepare(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingPaymentPrepareMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingPaymentPrepare>>
>;
export type BillingPaymentPrepareMutationBody =
  BodyType<BillingPaymentPrepareRequest>;
export type BillingPaymentPrepareMutationError = ErrorType<unknown>;

/**
 * @summary 결제 준비 (orderId 발급)
 */
export const useBillingPaymentPrepare = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingPaymentPrepare>>,
      TError,
      { data: BodyType<BillingPaymentPrepareRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingPaymentPrepare>>,
  TError,
  { data: BodyType<BillingPaymentPrepareRequest> },
  TContext
> => {
  const mutationOptions = getBillingPaymentPrepareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 7일 이내 환불 가능한 결제 목록.

조건: status=PAID + paid_at >= now-7d + refunded_at is null + is_recurring=False.
프론트가 거래내역 위쪽에 "환불 가능 결제" 섹션을 표시할 때 사용.
 * @summary 환불 가능 결제 목록 (7일 이내)
 */
export const billingPaymentsRefundable = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Payment[]>(
    { url: `/api/billing/payments/refundable/`, method: "GET", signal },
    options,
  );
};

export const getBillingPaymentsRefundableQueryKey = () => {
  return [`/api/billing/payments/refundable/`] as const;
};

export const getBillingPaymentsRefundableQueryOptions = <
  TData = Awaited<ReturnType<typeof billingPaymentsRefundable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof billingPaymentsRefundable>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingPaymentsRefundableQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingPaymentsRefundable>>
  > = ({ signal }) => billingPaymentsRefundable(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingPaymentsRefundable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingPaymentsRefundableQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingPaymentsRefundable>>
>;
export type BillingPaymentsRefundableQueryError = ErrorType<unknown>;

export function useBillingPaymentsRefundable<
  TData = Awaited<ReturnType<typeof billingPaymentsRefundable>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPaymentsRefundable>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsRefundable>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsRefundable>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPaymentsRefundable<
  TData = Awaited<ReturnType<typeof billingPaymentsRefundable>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPaymentsRefundable>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPaymentsRefundable>>,
          TError,
          Awaited<ReturnType<typeof billingPaymentsRefundable>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPaymentsRefundable<
  TData = Awaited<ReturnType<typeof billingPaymentsRefundable>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPaymentsRefundable>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 환불 가능 결제 목록 (7일 이내)
 */

export function useBillingPaymentsRefundable<
  TData = Awaited<ReturnType<typeof billingPaymentsRefundable>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPaymentsRefundable>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingPaymentsRefundableQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 가상계좌 입금 완료·결제 만료 등 Toss 비동기 이벤트를 수신합니다. 본문 형식은 Toss가 정의하며 이벤트 종류에 따라 다릅니다.
 * @summary 토스페이먼츠 웹훅 수신
 */
export const billingTossWebhook = (
  billingTossWebhookRequest: BodyType<BillingTossWebhookRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/webhooks/toss/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: billingTossWebhookRequest,
      signal,
    },
    options,
  );
};

export const getBillingTossWebhookMutationOptions = <
  TError = ErrorType<void | void | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingTossWebhook>>,
    TError,
    { data: BodyType<BillingTossWebhookRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingTossWebhook>>,
  TError,
  { data: BodyType<BillingTossWebhookRequest> },
  TContext
> => {
  const mutationKey = ["billingTossWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingTossWebhook>>,
    { data: BodyType<BillingTossWebhookRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return billingTossWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingTossWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingTossWebhook>>
>;
export type BillingTossWebhookMutationBody =
  BodyType<BillingTossWebhookRequest>;
export type BillingTossWebhookMutationError = ErrorType<void | void | void>;

/**
 * @summary 토스페이먼츠 웹훅 수신
 */
export const useBillingTossWebhook = <
  TError = ErrorType<void | void | void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingTossWebhook>>,
      TError,
      { data: BodyType<BillingTossWebhookRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof billingTossWebhook>>,
  TError,
  { data: BodyType<BillingTossWebhookRequest> },
  TContext
> => {
  const mutationOptions = getBillingTossWebhookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
